<!--Lista de afiliaciones y de eventos(Cuando este desarrollada esta funcionalidad) que ha adqurido un usuario-->
<template>
  <v-row justify="center" style="min-height:40vh">
    <!-- EN CASO DE NO TENER EVENTOS (LANDING)-->
    <v-col cols="11" v-if="items.length===0 && user.role == 'ATTENDEE' && !affiliations" class="text-center">
      <v-alert prominent class="info white--text font-weight-bold">
        <v-row align="center"> 
          <v-col>
            <p>Aún no se ha registrado a ningún evento.</p>
            <v-row justify="center">
              <v-btn
                to="/eventos"
                x-large
                color="primary"
                class="font-weight-bold"
              >¡Quiero ver todos los eventos!</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-alert>
    </v-col>
    <!-- EN CASO DE NO TENER AFILIACIONES (ASISTENTE)-->
    <v-col cols="10" md="8" v-else-if="!items.length && user.role == 'ATTENDEE' && affiliations" class="text-center">
      <v-alert prominent class="info white--text font-weight-bold">
        <v-row align="center">
          <v-col>
            <p>Actualmente no está afiliado a ninguna organización.</p>
            <v-row justify="center">
              <v-btn
                to="/afiliaciones"
                x-large
                color="primary"
                class="font-weight-bold"
              >¡Quiero ver más afiliaciones!</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-alert>
    </v-col>
    <!-- EN CASO DE NO TENER PRODUCTOS -->

    <!-- LISTA DE EVENTOS -->
    <v-col
      cols="11"
      md="6"
      v-for="item in paginatedData"
      :key="item.id"
      class="mb-5"
    >
      <event-item v-if="!affiliations" :event="item"></event-item>
      <affiliation-item v-else :affiliation="item"></affiliation-item>
    </v-col>
    <!-- LISTA DE EVENTOS -->

    <!-- PAGINACIÓN DE EVENTOS -->
    <v-pagination
      v-if="!notPaginated"
      color="secondary"
      v-show="items.length"
      v-model="page"
      :length="pages"
      :total-visible="8"
      circle
      @next="goTop()"
      @previous="goTop()"
    ></v-pagination>
    <!-- PAGINACIÓN DE EVENTOS -->
  </v-row>
</template>

<script>
import eventItem from "./eventItem";
import affiliationItem from "./affiliationItem";
import { mapState } from "vuex";
export default {
  components: {
    eventItem,
    affiliationItem
  },
  props: {
    items: { type: Array, required: true },
    notPaginated: { type: Boolean, required: false },
    affiliations: { type: Boolean, required: false }
  },
  data() {
    return {
      itemsPerPage: 8,
      page: 1
    };
  },
  computed: {
    ...mapState("user", ["user"]),

    /**
     * Función que calcula la cantidad de páginas a mostrar.
     */
    pages() {
      return this.itemsPerPage
        ? Math.ceil(this.items.length / this.itemsPerPage)
        : 0;
    },

    /**
     * Función que obtiene los items a mostrar en una página en específico.
     */
    paginatedData() {
      return this.items.slice(
        this.page * this.itemsPerPage - this.itemsPerPage,
        this.page * this.itemsPerPage
      );
    }
  },
  methods:{
    /**
     * Función para ir a una posición específica en el navegador (Programmatic Scrolling).
     */
    goTop(){
      this.$vuetify.goTo(0, {duration:300, easing:'linear'})
    }
  }
};
</script>
<style scoped>
.v-pagination>>>.v-pagination__item:focus{
    outline: white auto 0px;
}
.v-pagination>>>.v-pagination__navigation:focus{
    outline: white auto 0px;
}
</style>